// src/hooks/useFilter.ts
import { useState } from 'react';

export interface FilterValues {
  function_l1: string;
  function_l2: string;
  function_l3: string;
  function_l4: string;
  [key: string]: string; // Index signature
}

const useFilter = () => {
    const [filterValues, setFilterValues] = useState<FilterValues>({
      function_l1: '',
      function_l2: '',
      function_l3: '',
      function_l4: '',
      // any other defaults
    });
  
    const applyFilter = (filters: FilterValues): FilterValues => {
      setFilterValues(filters);
      return filters;
    };
  
    const resetFilter = (): FilterValues => {
      const defaultFilters = {
        function_l1: '',
        function_l2: '',
        function_l3: '',
        function_l4: '',
        // default values here
      };
      setFilterValues(defaultFilters);
      return defaultFilters;
    };
  
    return {
      filterValues,
      applyFilter,
      resetFilter,
    };
  };
  
export default useFilter;
  